export default "__VITE_ASSET__jlXBvuOH__"